import React, { useState } from 'react';
import { signUp } from './firebase';  // no longer need `auth` here
import { Link, useNavigate } from 'react-router-dom';
import logo from './assets/Logo.png'; 
import './SignUp.css';

function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await signUp(email, password, name);
      alert('✅ Sign-up successful! Please check your email to verify your account.');
      navigate('/signin');
    } catch (err) {
      console.error('❌ Sign-up error:', err);
      setError('Sign-up failed. Please try again.');
    }
  };

  return (
    <div className="signup-container">
      <img src={logo} alt="Academic Vocabulary Booster Logo" className="logo" />
      <h2>Create an Account</h2>

      <form onSubmit={handleSignUp} className="signup-form">
        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        /><br />
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        /><br />
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        /><br />

        <button type="submit">Sign Up</button>

        {error && <p className="error-message">{error}</p>}
      </form>

      <p className="switch-page">
        Already have an account? <Link to="/signin">Sign In</Link>
      </p>
    </div>
  );
}

export default SignUp;
